import {
  IconBanOutline,
  IconCheckCircleFilled,
  IconExclamationTriangleOutline,
} from '@iwoca/icons';
import { AlertBox } from '@iwoca/orion';
import { Trans } from '@lingui/react/macro';

import styles from './TrueLayerAlertBox.module.css';
import { TTrueLayerAlertStatus } from '../../../../types';

const TrueLayerAlertBox = ({
  status,
  successorName,
}: {
  status: Exclude<TTrueLayerAlertStatus, null>;
  successorName?: string;
}) => {
  if (status === 'success') {
    return (
      <AlertBox
        variant={status}
        className={styles.alertBox}
        data-testid="alertbox"
      >
        <IconCheckCircleFilled
          width={20}
          height={20}
          className={styles.successAlertBoxIcon}
        />
        <span>
          <Trans>Your TrueLayer account has been linked successfully!</Trans>
        </span>
      </AlertBox>
    );
  }
  if (status === 'cancel') {
    return (
      <AlertBox
        variant={status}
        className={styles.alertBox}
        data-testid="alertbox"
      >
        <IconBanOutline
          width={20}
          height={20}
          className={styles.cancelAlertBoxIcon}
        />
        <span>
          <span className={styles.bold}>
            <Trans>We didn’t get your permission to link your account.</Trans>
          </span>
        </span>
      </AlertBox>
    );
  }

  if (status === 'provider_migrated') {
    return (
      <AlertBox
        variant="failure"
        className={styles.alertBox}
        data-testid="alertbox"
      >
        <IconExclamationTriangleOutline
          width={20}
          height={20}
          className={styles.failureAlertBoxIcon}
        />
        <span className={styles.bold}>
          {successorName ? (
            <Trans>
              Your bank has moved to {successorName}. Please reconnect using{' '}
              {successorName} to link your account.
            </Trans>
          ) : (
            <Trans>
              Your bank has moved to a new provider. Please reconnect to link
              your account.
            </Trans>
          )}
        </span>
      </AlertBox>
    );
  }

  return (
    <AlertBox
      variant="failure"
      className={styles.alertBox}
      data-testid="alertbox"
    >
      <IconExclamationTriangleOutline
        width={20}
        height={20}
        className={styles.failureAlertBoxIcon}
      />
      <span className={styles.bold}>
        <Trans>
          Something went wrong while linking your TrueLayer account. Try again.
        </Trans>
      </span>
    </AlertBox>
  );
};

export default TrueLayerAlertBox;
